import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  href,
  children,
  className,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors rounded-md focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2';
  const variants = {
    primary: 'bg-brand-600 text-white hover:bg-brand-700 shadow-sm',
    secondary: 'bg-slate-900 text-white hover:bg-slate-800 shadow-sm',
    outline: 'border border-slate-200 bg-white text-slate-900 hover:bg-slate-50 hover:text-slate-900',
    ghost: 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-10 px-6 text-sm',
    lg: 'h-12 px-8 text-base'
  };
  const classes = twMerge(baseStyles, variants[variant], sizes[size], className);
  if (href) {
    return <Link to={href} className={classes} data-id="element-14">
        {children}
      </Link>;
  }
  return <button className={classes} {...props} data-id="element-15">
      {children}
    </button>;
}